/*
 * @Description:
 * @Author: WangYuhan
 * @Date: 2022-09-19 10:25:05
 * @LastEditTime: 2023-10-10 11:05:15
 * @LastEditors: WangYuhan
 */
import Vue from 'vue';
import Vuex from 'vuex';
import getters from './getters';
// 路由存放位置
import Layout from './modules/Layout';
// 饿了么UI一些配置属性
import element from './modules/element';

Vue.use(Vuex);
// https://webpack.js.org/guides/dependency-management/#requirecontext
const modulesFiles = require.context('./modules', true, /\.js$/);

// you do not need `import app from './modules/app'`
// it will auto require all vuex module from modules file
const modules = modulesFiles.keys().reduce((modules, modulePath) => {
  // set './app.js' => 'app'
  const moduleName = modulePath.replace(/^\.\/(.*)\.\w+$/, '$1');
  const value = modulesFiles(modulePath);
  modules[moduleName] = value.default;
  return modules;
}, {});

// 自动导入Module模块
const viewModules = {};
const viewModuleFiles = require.context('../views', true, /Module.js$/);
viewModuleFiles.keys().forEach(key => {
  const keys = key.replace(/(\.\/|\.js)/g, '');
  const moduleName = _.last(keys.split('/'));
  viewModules[moduleName] = viewModuleFiles(key).default;
});

const store = new Vuex.Store({
  getters,
  modules: {
    Layout,
    element,
    ...modules,
    ...viewModules,
  },
});

export default store;
